import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLogin, setLogout } from "../Redux/Feature/loginSlice";
import { Divider } from "@mui/material";
import { roles, userPermissions } from "../Utils/constants";
import { useCommonUserProvider } from "../Providers/Common/User";
import api from "../Utils/api";

export default function AccountProfileMenu(props) {
  const { getHybridUserDetails, loading } = useCommonUserProvider();
  const [switchChecked, setSwitchChecked] = useState(
    useSelector((state) => state.user.role) === roles.vendor
  );
  const [role, setRole] = useState(useSelector((state) => state.user.role));
  const permissions = useSelector((state) => state.user.permissions);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const open = Boolean(props.menuState);
  const handleClose = () => {
    props.setMenuState(!props.menuState);
  };

  useEffect(() => {}, [props.menuState, role, switchChecked]);

  const logout = () => {
    localStorage.removeItem("persist:root");
    localStorage.removeItem("userId");
    localStorage.removeItem("rft");
    localStorage.removeItem("newPassword");
    localStorage.removeItem("email");
    delete api.defaults.headers["Role"];
    dispatch(setLogout());
    navigate("/");
  };

  const handleRoleChange = (e) => {
    setSwitchChecked(!switchChecked);
    getHybridUserDetails()
      .then((res) => {
        api.defaults.headers["Role"] = res.data?.result?.role;
        setRole(res.data?.result?.role);
        dispatch(
          setLogin({
            role: res.data?.result?.role,
            userId: res.data?.result?.id,
            isHybridConsultant: true,
            permissions: permissions,
          })
        );
        localStorage.setItem("userId", res.data?.result.id);
        props.setReload(true);
      })
      .catch((err) => {
        console.log(err);
      });
    //window.location.reload()
  };

  return (
    <Menu
      anchorEl={props.menuState}
      id="account-menu"
      open={open}
      onClose={handleClose}
      //onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 9.5,
          borderRadius: 3,
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "top" }}
    >
      <div className="w-72 pl-6 pr-6 pb-6 pt-2">
        <h1 className="font-bold text-lg">
          {role === roles.vendor || role === roles.client
            ? props.user.company
            : props.user.name}
        </h1>
        <h1 className="text-gray-600 text-base">
          ProLegion ID {props.user.username}
        </h1>
        <br />
        <h1
          className="text-sm text-gray-500 cursor-pointer"
          onClick={(e) => {
            navigate("my-account");
            handleClose();
          }}
        >
          {role === roles.vendor || role === roles.client ? (
            <span>
              <WorkOutlineOutlinedIcon />{" "}
              <span className="ml-3">Business Details</span>
            </span>
          ) : (
            <span>
              <PersonIcon />
              <span className="ml-3">Personal Details</span>
            </span>
          )}
        </h1>
        <br />
        {!permissions.includes(`admin-${role.toLowerCase()}`) ? (
          <>
            <h1
              className="text-sm text-gray-500 cursor-pointer"
              onClick={(e) => {
                navigate("/dashboard/user/profile");
                handleClose();
              }}
            >
              <span>
                <PersonIcon />
                <span className="ml-3">Personal Details</span>
              </span>
            </h1>
            <br />
          </>
        ) : null}
        {permissions.includes(`admin-${role.toLowerCase()}`) ||
        permissions.includes(userPermissions.settings.edit) ? (
          <>
            <h1
              className="text-sm text-gray-500 cursor-pointer"
              onClick={(e) => {
                navigate("settings");
                handleClose();
              }}
            >
              <Settings /> <span className="ml-3">Settings</span>
            </h1>
            <br />
          </>
        ) : null}
        <h1 className="text-sm text-gray-500 cursor-pointer">
          <HelpOutlineOutlinedIcon /> <span className="ml-3">Help Center</span>
        </h1>
        <br />
        <h1 className="text-sm text-gray-500 cursor-pointer" onClick={logout}>
          <Logout /> <span className="ml-3">Logout</span>
        </h1>
        {useSelector((state) => state.user.isHybridConsultant) && (
          <div>
            <br />
            <Divider className="p-2" />
            <br />
            <div className="inline">
              <IOSSwitch
                checked={switchChecked}
                onChange={(e) => handleRoleChange(e)}
              />
              &nbsp;&nbsp;&nbsp;
              <h1 className="text-sm text-center inline font-semibold">
                Switch to {switchChecked ? "Consultant" : "Vendor"} profile
              </h1>
            </div>
          </div>
        )}
      </div>
    </Menu>
  );
}

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#2EBAA3",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
